import React, { useEffect, useRef, useState } from "react";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ic_no_image from "../img/ic_no_image_available_big.png";

import ic_car_model_1 from "../img/ic_toyota_model_1.png";
import ic_car_model_2 from "../img/ic_toyota_model_2.png";
import ic_car_model_3 from "../img/ic_toyota_model_3.png";
import ic_car_model_4 from "../img/ic_toyota_model_4.png";
import ic_car_model_5 from "../img/ic_toyota_model_5.png";
import ic_car_model_6 from "../img/ic_toyota_model_6.png";
import ic_car_model_7 from "../img/ic_toyota_model_7.png";
import ic_car_model_8 from "../img/ic_toyota_model_8.png";

import ic_dropdwon from "../img/ic_down_dropdown.png";

import "../css/CarModel.css";

import "../css/ItemSingleCard.css";

function Group() {

    const [imageNotAvailable, setImageNotAvailable] = useState(false);

    const makeRef = useRef("ALL");
    const modelRef = useRef("ALL");

    const getValuesFromLocalStorage = ()=>{
        if (localStorage.getItem("selected_make") != null) {
            makeRef.current = localStorage.getItem("selected_make")
        }
        if (localStorage.getItem("selected_model") != null) {
            modelRef.current = localStorage.getItem("selected_model")
        }
    }

    getValuesFromLocalStorage()

    const [isCallingModelAPI, setIsCallingModelAPI] = useState(false)
    const [isCallingGroupAPI, setIsCallingGroupAPI] = useState(false)

    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('make')) {
        makeRef.current = searchParams.get('make')
    }
    const [arrayOfPartsGroup, setArrayOfPartsGroup] = useState(null)
    const [arrayOfModels, setArrayOfModels] = useState(null)

    let pathArray = [{ name: "make", path: "" },{ name: "model", path: "model" },
    { name: "group", path: "group" }]
    const navigate = useNavigate();

    const [showYearDropDown, setShowYearDropDown] = useState(false);
    const [selectedYear, setSelectedYear] = useState("Select");
    const [listOfYears, setListOfYears] = useState([])


    const getCarPartsGroup = () => {

        setIsCallingGroupAPI(true)
        axios.get('https://cubixweberp.com:197/api/InventMasters/InventoryLevel4?cmpcode=AUTOLAND&guid=82D38C38-65BF-46AF-8871-D8219757842C&mod=LEVEL4&lvl1=A1&lvl2=A2&lvl3=A3').then((res) => {
            console.log("res ", res)
            setArrayOfPartsGroup(res.data)
            setIsCallingGroupAPI(false)
        }).catch((err) => {
            console.log("err ", err)
            setIsCallingGroupAPI(false)
        })

    }

    useEffect(() => {
        getCarPartsGroup()
    }, [])

    const clickedOnGoToItems = (group_original_name) => {
        navigate('/parts')
        localStorage.setItem("selected_group", group_original_name)
    }

    const addDefaultSrc = (ev, itemName) => {
        console.log("error loading image of ", itemName)
        ev.target.style.display = 'none';
        console.log("ev.target.nextElementSibling  ", ev.target.nextElementSibling)

        //ev.target.nextElementSibling.src ="../img/ic_no_image_available_big.png"
        ev.target.nextElementSibling.style.display = 'block';
    }

    const reCallApi =()=>{

        getValuesFromLocalStorage()

        getCarPartsGroup()

    }

    return (
        <div className="CarModels-root-container common_page_bg">

            <Header />

            {/* part section */}
            <div className="container mt-0 pb-4">

                

                <div className="d-flex justify-content-between align-items-center mt-4">
                    <h5>Select group</h5>
                    <button className="btn btn-warning" onClick={() => clickedOnGoToItems("ALL")}>All</button>
                </div>


                {
                    isCallingGroupAPI &&
                    <div>
                        <div class="spinner-border text-light" role="status">


                        </div>
                    </div>
                }

                <div className="CarModel-brand-container mt-4">

                    {
                        arrayOfPartsGroup != null ?
                            arrayOfPartsGroup.map((item) => {
                                return (
                                    <div onClick={() => clickedOnGoToItems(item.group)} className="CarModels-item-card">

                                        <label>{item.group}</label>
                                        <img className="ItemSingleCard-inner-container-item-image" src={`http://autoland1.fortiddns.com:83/group/${item.group.replace(/ +/g, "").trim()}.png`}
                                            onError={(e) => addDefaultSrc(e, item.group)} />
                                        <img className="hidden-image-if-error" src={ic_no_image}
                                        />
                                    </div>
                                )
                            })
                            :
                            null
                    }

                </div>
            </div>



        </div>
    )
}

export default Group;